<ng-container *ngIf="isVersion2()">
  <!--<div class="row" *ngIf="isWorkflowOnSubscriber || isWorkflowPgpv">
    <div class="col-sm-6">
      <h2 class="mt-4">{{'CardObservations.ObservationsSubscriber' | translate}}</h2>
    </div>
  </div>-->
  <!--<div class="form-group" *ngIf="isWorkflowOnSubscriber || isWorkflowPgpv">
    <label for="Observation">{{'CardObservations.Observation' | translate}}</label>
    <textarea class="form-control" id="subsObservation" placeholder="{{'CardObservations.ObsText' | translate}}" [(ngModel)]="cardData.subsObservation"
              #subsObservation="ngModel"
              name="subsObservation" rows="10" cols="100" maxlength="1000"></textarea>
    <validation-message [control]="subsObservation"></validation-message>
  </div>-->

  <div class="row">
    <div class="col-sm-6">
      <!--<h2 class="mt-4">{{((isWorkflowOnSubscriber || isWorkflowPgpv) ? 'CardObservations.ObservationsService' : 'CardObservations.ObservationsSubscriber') | translate}}</h2>-->
      <h2>Outras Informações</h2>
    </div>
  </div>
  <div class="row" *ngIf="parentWorkflow.workflowInstance.workflowCode.indexOf('PEDI001') > -1" >
    <div *ngIf="professionalClass === '5' || professionalClass === '4'" class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="isWorkflowOnSubscriber?'disabled':''">
          <label for="JubilationRetirement" [ngClass]="isWorkflowOnSubscriber?'disabled':''">
            <span class="mandatory">*</span>Aposentação com jubilação<span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Indique se pretende aposentação com jubilação"></span>
          </label>

          <div class="btn-group btn-group-toggle">
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.jubilationRetirement" [radioLabel]="jubilationRetirement">
              <input type="radio" [(ngModel)]="cardData.jubilationRetirement" name="jubilationRetirement" #jubilationRetirement="ngModel" [value]="domain.value" required
                     [clearRelated]="{model : this.cardData , propsToReset : ['workAbroadList']} ">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>


    <div *ngIf="!isWorkflowOnSubscriber && isSpecificLegalFundament()" class="col-sm-4">
      <div class="form-group">
        <label *ngIf="(subscriberType === '01' || subscriberType === '03') && professionalClass !== '18'"><span class="mandatory">*</span>Data efeito de aposentação<span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Indique a data de efeito de aposentação"></span></label>
        <label *ngIf="(subscriberType === '02' || subscriberType === '03') && (professionalClass === '17' || professionalClass === '18')"><span class="mandatory">*</span>Data efeito da reforma<span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Indique a data de efeito de reforma"></span></label>
        <div class="input-group">
          <input #dpRetirementDate="bsDatepicker" bsDatepicker
                 type="text"
                 [minDate]="minDate"
                 [maxDate]="maxDate"
                 class="form-control DatepickerCustomClasse"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                 [(ngModel)]="cardData.retirementDate" name="retirementDate" #retirementDate="ngModel" required
                 maxlength="10"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpRetirementDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpRetirementDate.isDisabled && dpRetirementDate.toggle()">
            <span class="input-group-text">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="retirementDate"></validation-message>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isWorkflowOnSubscriber" class="form-group">
    <label for="Observation">{{'CardObservations.Observation' | translate}}</label>
    <textarea class="form-control" style="height:100% !important" id="SubsObservation" placeholder="{{'CardObservations.ObsText' | translate}}" [(ngModel)]="cardData.SubsObservation"
              #subsObservation="ngModel"
              name="SubsObservation" rows="10" cols="100" maxlength="1000" [disabled]="!isWorkflowOnSubscriber"></textarea>
    <validation-message [control]="SubsObservation"></validation-message>
  </div>

  <div class="form-group">
    <label *ngIf="!isWorkflowOnSubscriber" for="Observation">{{'CardObservations.Observation' | translate}}</label>
    <label *ngIf="isWorkflowOnSubscriber" for="Observation">Observações adicionais do serviço relevantes ao pedido</label>
    <textarea class="form-control" style="height:100% !important" id="servObservation" placeholder="{{'CardObservations.ObsText' | translate}}" [(ngModel)]="cardData.servObservation"
              #servObservation="ngModel"
              name="servObservation" rows="10" cols="100" maxlength="1000" [disabled]="isWorkflowOnSubscriber"></textarea>
    <validation-message [control]="servObservation"></validation-message>
  </div>

  <!--<div class="row" *ngIf="needRevision == true">
    <div class="col-sm-6">
      <h2 class="mt-4">{{'CardObservations.RevisionTitle' | translate}}</h2>
    </div>
  </div>
  <div class="form-group" *ngIf="needRevision == true">
    <label for="Observation">{{'CardObservations.Revision' | translate}}</label>
    <textarea class="form-control" id="revisionReason" [(ngModel)]="revisionReason"
              #servObservation="ngModel"
              name="revisionReason" rows="10" cols="100" maxlength="512" disabled></textarea>
  </div>-->
<div class="row" *ngIf="(parentWorkflow.workflowInstance.workflowCode.indexOf('PEDI0020') == -1 && parentWorkflow.workflowInstance.workflowCode.indexOf('PEDI008') == -1) && (parentWorkflow.workflowInstance.formData['StepServiceInfo']['ServiceIdentification']['code'] !== '2251' && !isWorkflowIncapacity && (isWorkflowOnSubscriber || isWorkflowPgpv))">
  <div class="col-sm-4">
    <div class="form-group">
      <label for="PrevComunicationValue">
        <span class="mandatory">*</span>{{'CardCommunicationDetails.PrevComunicationValue' | translate}}
        <button type="button"
                class="btn-icon text-primary icon-help"
                aria-label="Tooltip com informação"
                tooltip="{{'Tooltips.CardCommunicationDetails.PrevComunicationValue' | translate}}"></button>
      </label>
      <div class="btn-group btn-group-toggle">
        <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==parentWorkflow.workflowInstance.formData['StepObs']['CommunicationDetail'].prevComunicationValue" [radioLabel]="prevComunicationValue">
          <input type="radio" [(ngModel)]="parentWorkflow.workflowInstance.formData['StepObs']['CommunicationDetail'].prevComunicationValue" name="prevComunicationValue" #prevComunicationValue="ngModel" [value]="domain.value" required
                 [clearRelated]="{model : parentWorkflow.workflowInstance.formData['StepObs']['CommunicationDetail'] , propsToReset : ['reflectionDeadlineCode']}" (ngModelChange)="onPrevComChanged($event)">
          {{domain.description}}
        </label>
        <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
      </div>
    </div>
  </div>
  <div class="col-sm-4">
    <div class="form-group">
      <label for="ReflectionDeadline" [class.disabled]="parentWorkflow.workflowInstance.formData['StepObs']['CommunicationDetail'].prevComunicationValue?.toString() != 'true'">
        <span class="mandatory" *ngIf="parentWorkflow.workflowInstance.formData['StepObs']['CommunicationDetail'].prevComunicationValue && parentWorkflow.workflowInstance.formData['StepObs']['CommunicationDetail'].prevComunicationValue?.toString() == 'true'">*</span>
        {{'CardCommunicationDetails.ReflectionDeadline' | translate}}
        <button type="button"
                class="btn-icon text-primary icon-help"
                aria-label="Tooltip com informação"
                tooltip="{{'Tooltips.CardCommunicationDetails.ReflectionDeadline' | translate}}"></button>
      </label>
      <select class="custom-select" [(ngModel)]="parentWorkflow.workflowInstance.formData['StepObs']['CommunicationDetail'].reflectionDeadlineCode" name="reflectionDeadlineCode" #reflectionDeadlineCode="ngModel"
              [required]="parentWorkflow.workflowInstance.formData['StepObs']['CommunicationDetail'].prevComunicationValue && parentWorkflow.workflowInstance.formData['StepObs']['CommunicationDetail'].prevComunicationValue?.toString() == 'true'"
              [disabled]="parentWorkflow.workflowInstance.formData['StepObs']['CommunicationDetail'].prevComunicationValue?.toString() != 'true'"
              [dropdownTitle]="{value : cardData.reflectionDeadlineCode , dimensions : reflectionDeadlines }" nullableSelect>
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of getOrderReflectionDeadlines()" [value]="domain.code">
          {{domain.description}}
        </option>
      </select>
      <validation-message [control]="reflectionDeadlineCode"></validation-message>
    </div>

  </div>
</div>
</ng-container>



<ng-container *ngIf="!isVersion2()">
  <div class="row" *ngIf="isWorkflowOnSubscriber || isWorkflowPgpv">
    <div class="col-sm-6">
      <h2 class="mt-4">{{'CardObservations.ObservationsSubscriber' | translate}}</h2>
    </div>
  </div>
  <div class="form-group" *ngIf="isWorkflowOnSubscriber || isWorkflowPgpv">
    <label for="Observation">{{'CardObservations.Observation' | translate}}</label>
    <textarea class="form-control" style="height:100% !important" id="subsObservation" placeholder="{{'CardObservations.ObsText' | translate}}" [(ngModel)]="cardData.subsObservation"
              #subsObservation="ngModel"
              name="subsObservation" rows="10" cols="100" maxlength="1000"></textarea>
    <validation-message [control]="subsObservation"></validation-message>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <h2 class="mt-4">{{((isWorkflowOnSubscriber || isWorkflowPgpv) ? 'CardObservations.ObservationsService' : 'CardObservations.ObservationsSubscriber') | translate}}</h2>
    </div>
  </div>

  <div class="form-group">
    <label for="Observation">{{'CardObservations.Observation' | translate}}</label>
    <textarea class="form-control" style="height:100% !important" id="servObservation" placeholder="{{'CardObservations.ObsText' | translate}}" [(ngModel)]="cardData.servObservation"
              #servObservation="ngModel"
              name="servObservation" rows="10" cols="100" maxlength="1000" [disabled]="isWorkflowOnSubscriber"></textarea>
    <validation-message [control]="servObservation"></validation-message>
  </div>

  <div class="row" *ngIf="needRevision == true">
    <div class="col-sm-6">
      <h2 class="mt-4">{{'CardObservations.RevisionTitle' | translate}}</h2>
    </div>
  </div>
  <div class="form-group" *ngIf="needRevision == true">
    <label for="Observation">{{'CardObservations.Revision' | translate}}</label>
    <textarea class="form-control" id="revisionReason" style="height:100% !important" [(ngModel)]="revisionReason"
              #servObservation="ngModel"
              name="revisionReason" rows="10" cols="100" maxlength="512" disabled></textarea>
  </div>
</ng-container>

<!--<pre>{{cardData | json}}</pre>-->
